var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-loop-func */
import useSWR from 'swr';
import { parseISO } from 'date-fns';
import { useMemo } from 'react';
import { defaultTheme } from '@hn-ui/themes';
import { Categories } from './PieValue';
import { GradeInfo, Grades, isTbd, getGradeByValue, } from '../../../../landing/models/GradeInfo';
import { SortGroupType, } from './StudentList/Table/ITableInfo';
import { Direction, SortTypes } from './StudentList/SortMenu/SortMenuInfo';
import { getColorByResultPosition } from '../../../../landing/utils/TestHelper';
import { TestPositionColor } from '../../Common/colors';
export var escapeSpecialSymbols = function (text) {
    return text === null || text === void 0 ? void 0 : text.replace(/&#39;/g, "'").replace(/&amp;/g, '&');
};
var fetcher2 = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url)];
            case 1:
                res = _a.sent();
                if (!res.ok) {
                    throw new Error('An error occurred');
                }
                return [2 /*return*/, res.json()];
        }
    });
}); };
export var getDiagramsDataRelativeUrl = function (groupId, accountType, schoolId) {
    return "/api/teachers/groups/" + groupId + "/yearly_charts?role=" + accountType + "&school_id=" + schoolId;
};
var transformProgressPieData = function (data) {
    var output = [
        {
            id: Categories.C1,
            color: defaultTheme.colors.green99,
        },
        {
            id: Categories.C2,
            color: defaultTheme.colors.green95,
        },
        {
            id: Categories.C3,
            color: defaultTheme.colors.green70,
        },
        {
            id: Categories.C4,
            color: defaultTheme.colors.green40,
        },
        {
            id: Categories.C5,
            color: defaultTheme.colors.green20,
        },
    ];
    // output.forEach((d) => {
    //   (d.students = []), (d.value = Math.round(Math.random() * 10 + 1));
    // });
    if (!Array.isArray(data))
        return output;
    data.forEach(function (_a) {
        var name = _a.name, students = _a.students;
        var category;
        switch (name) {
            case 'below_30':
                category = Categories.C1;
                break;
            case 'between_30_and_50':
                category = Categories.C2;
                break;
            case 'between_50_and_80':
                category = Categories.C3;
                break;
            case 'between_80_and_100':
                category = Categories.C4;
                break;
            case 'over_100':
                category = Categories.C5;
                break;
            default:
                break;
        }
        var pie = output.find(function (i) { return i.id === category; });
        if (pie) {
            pie.value = students.length;
            pie.students = students.map(function (name) {
                return ({
                    name: name,
                });
            });
        }
    });
    return output;
};
var transformDistributionPieData = function (data) {
    var output = [
        {
            id: Grades.TBD,
            color: '#C5C7D4',
        },
        {
            id: Grades.PK,
            color: '#DA3D4D',
        },
        {
            id: Grades.K,
            color: '#FD7B88',
        },
        {
            id: Grades.G1,
            color: '#9ED9FC',
        },
        {
            id: Grades.G2,
            color: '#42ABE9',
        },
        {
            id: Grades.G3,
            color: '#1A95DE',
        },
        {
            id: Grades.G4,
            color: '#1982BF',
        },
        {
            id: Grades.G5,
            color: '#126799',
        },
    ];
    if (!Array.isArray(data))
        return output;
    data.forEach(function (_a) {
        var name = _a.name, students = _a.students;
        var pie = output.find(function (i) { return i.id === (isTbd(name.toString()) ? -2 : name); });
        if (pie) {
            pie.value = students.length;
            pie.students = students.map(function (name) {
                return ({
                    name: name,
                });
            });
        }
    });
    return output;
};
var transformDiagramsData = function (data) {
    var output = {
        progressData: {},
        distributionData: {},
        readinessData: {},
        studentsData: new Map(),
    };
    if (!data || typeof data !== 'object')
        return null;
    var nextGrade = (isTbd(data.progressData.nextGroupGradeValue.toString())
        ? Grades.TBD
        : data.progressData.nextGroupGradeValue);
    if (data.progressData) {
        output.progressData = {
            average: data.progressData.average.toString(),
            pieData: [],
        };
        output.readinessData = {
            total: data.progressData.total.toString(),
            nextGradeReady: data.progressData.nextGradeReady.toString(),
            grade: GradeInfo.get(nextGrade),
            eoyReady: data.progressData.nextGradeReadyByEOY.toString(),
            eoyTestReady: Number.parseInt(data.progressData.completedEOY.toString(), 10),
        };
        if (typeof data.progressData.progressPieData === 'object')
            output.progressData.pieData = transformProgressPieData(data.progressData.progressPieData);
    }
    if (data.distributionData) {
        var currentGrade_1 = (isTbd(data.progressData.groupGradeValue.toString())
            ? Grades.TBD
            : data.progressData.groupGradeValue);
        output.distributionData = {
            currentWeekCount: data.distributionData.practiceWeeksCount,
            startYearDate: parseISO(data.distributionData.beginningDate),
            startYearPieData: [],
            currentPieData: [],
            grade: currentGrade_1,
        };
        if (typeof data.distributionData.currentGradePieData === 'object')
            output.distributionData.currentPieData = transformDistributionPieData(data.distributionData.currentGradePieData);
        if (typeof data.distributionData.startYearPieData === 'object')
            output.distributionData.startYearPieData = transformDistributionPieData(data.distributionData.startYearPieData);
    }
    var currentGrade = Number.parseInt(data.progressData.groupGradeValue.toString(), 10);
    if (data.students) {
        var groupedByLevel = groupByLevel(data.students, currentGrade);
        output.studentsData.set(SortGroupType.Level, groupedByLevel);
        var groupedByTime = groupByTime(data.students, currentGrade);
        output.studentsData.set(SortGroupType.Time, groupedByTime);
        var groupedByCurrentLevel = groupByCurrentGrade(data.students, currentGrade);
        output.studentsData.set(SortGroupType.Grade, groupedByCurrentLevel);
        var groupedByStudents = groupByStudent(data.students, currentGrade);
        output.studentsData.set(SortGroupType.None, groupedByStudents);
    }
    output.startGrade = getGradeByValue(data.minGrade);
    output.endGrade = getGradeByValue(data.maxGrade);
    output.currentGrade = currentGrade;
    output.isClassPremium = data.premium;
    return output;
};
var parseLevel = function (resultPosition, value) {
    var level = resultPosition;
    var val = value;
    if (resultPosition === undefined) {
        level = 'n/a';
        val = undefined;
    }
    else if (resultPosition === 'not_tested') {
        level = 'n/a';
        val = -1;
    }
    return { level: level !== null && level !== void 0 ? level : '', value: val };
};
var parseTableRow = function (rows, groupGrade) {
    return rows.map(function (row) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        var boyParsed = parseLevel((_a = row.boy) === null || _a === void 0 ? void 0 : _a.resultPosition, (_b = row.boy) === null || _b === void 0 ? void 0 : _b.visible_quantile);
        var moyParsed = parseLevel((_c = row.moy) === null || _c === void 0 ? void 0 : _c.resultPosition, (_d = row.moy) === null || _d === void 0 ? void 0 : _d.visible_quantile);
        var eoyParsed = parseLevel((_e = row.eoy) === null || _e === void 0 ? void 0 : _e.resultPosition, (_f = row.eoy) === null || _f === void 0 ? void 0 : _f.visible_quantile);
        var parsedRow = {
            studentName: row.name.toString(),
            minInWeek: Number.parseInt(row.minInWeek.toString(), 10),
            progress: Number.parseInt(row.progress.toString(), 10),
            growth: row.growth !== null && row.growth !== undefined
                ? Number.parseInt(row.growth.toString(), 10)
                : undefined,
            boy: boyParsed.value,
            boyInfo: {
                header: 'Placement Test',
                level: boyParsed.level,
                range: (_g = row.boy) === null || _g === void 0 ? void 0 : _g.rangeMessage,
                color: getColorByResultPosition((_h = row.boy) === null || _h === void 0 ? void 0 : _h.resultColor),
            },
            moy: moyParsed.value,
            moyInfo: {
                header: 'Mid-Year Test',
                level: moyParsed.level,
                range: (_j = row.moy) === null || _j === void 0 ? void 0 : _j.rangeMessage,
                color: getColorByResultPosition((_k = row.moy) === null || _k === void 0 ? void 0 : _k.resultColor),
            },
            eoy: eoyParsed.value,
            eoyInfo: {
                header: 'End-of-Year Test',
                level: eoyParsed.level,
                range: (_l = row.eoy) === null || _l === void 0 ? void 0 : _l.rangeMessage,
                color: getColorByResultPosition((_m = row.eoy) === null || _m === void 0 ? void 0 : _m.resultColor),
            },
            studentTimelineUrl: row.studentTimelineUrl.toString(),
            sort: Number.parseInt(row.assessmentOrder, 10),
            startPoint: Number.parseInt(row.startPoint, 10),
        };
        if (Array.isArray(row.grades)) {
            var startPushGap_1 = 0;
            var startPushGrade_1 = row.grades.length
                ? Number.parseInt(row.grades[0].gradeValue.toString(), 10)
                : Grades.PK;
            var _loop_1 = function (g) {
                var grade = Number.parseInt(g.gradeValue.toString(), 10);
                var justBelowGrade = groupGrade - 1;
                var color = grade < groupGrade && grade < justBelowGrade
                    ? TestPositionColor.FAR_BELOW
                    : grade === justBelowGrade
                        ? TestPositionColor.BELOW
                        : grade === groupGrade
                            ? TestPositionColor.MEETS
                            : grade > groupGrade
                                ? TestPositionColor.EXCEEDS
                                : '';
                var pushedColor = grade < groupGrade && grade < justBelowGrade
                    ? TestPositionColor.FAR_BELOW
                    : grade === justBelowGrade
                        ? TestPositionColor.BELOW
                        : grade === groupGrade
                            ? TestPositionColor.MEETS
                            : grade > groupGrade
                                ? TestPositionColor.EXCEEDS
                                : '';
                var pushed = g.gaps.some(function (gap) {
                    return gap.replacedByTest;
                });
                parsedRow[grade] = {
                    pushed: pushed,
                    pushedColor: pushedColor,
                    info: g.gaps.map(function (gap) {
                        var start = Number.parseInt(gap.start, 10);
                        var end = Number.parseInt(gap.end, 10);
                        var pushed = Boolean(gap.replacedByTest);
                        var push;
                        if (pushed)
                            push = { startGrade: startPushGrade_1, startGap: startPushGap_1 };
                        startPushGap_1 = end;
                        startPushGrade_1 = grade;
                        if (start === end) {
                            if (start > 0) {
                                start--;
                            }
                            else {
                                end++;
                            }
                        }
                        return {
                            start: start,
                            end: end,
                            color: color,
                            push: push,
                        };
                    }),
                };
                var startGrade = (_r = (_q = (_p = (_o = parsedRow[grade]) === null || _o === void 0 ? void 0 : _o.info.find(function (i) { return i.push; })) === null || _p === void 0 ? void 0 : _p.push) === null || _q === void 0 ? void 0 : _q.startGrade) !== null && _r !== void 0 ? _r : -1;
                parsedRow[grade].pushedColor =
                    startGrade < groupGrade && startGrade < justBelowGrade
                        ? TestPositionColor.FAR_BELOW
                        : startGrade === justBelowGrade
                            ? TestPositionColor.BELOW
                            : startGrade === groupGrade
                                ? TestPositionColor.MEETS
                                : startGrade > groupGrade
                                    ? TestPositionColor.EXCEEDS
                                    : '';
            };
            for (var _i = 0, _s = row.grades; _i < _s.length; _i++) {
                var g = _s[_i];
                _loop_1(g);
            }
        }
        return parsedRow;
    });
};
var compare = function (a, b, direction) {
    var d = direction === Direction.Desc ? 1 : -1;
    // 'a' comes first (d > 0)
    if (a.group.sort < b.group.sort) {
        return -1 * d;
    }
    // 'b' comes first
    if (a.group.sort > b.group.sort) {
        return 1 * d;
    }
    return 0;
};
var compareRowsBySortField = function (a, b, direction) {
    if (a.startPoint === null ||
        a.startPoint === undefined ||
        b.startPoint === null ||
        b.startPoint === undefined)
        return 0;
    var d = direction === Direction.Desc ? 1 : -1;
    // 'a' comes first (d > 0)
    if (a.startPoint < b.startPoint) {
        return -1 * d;
    }
    // 'b' comes first
    if (a.startPoint > b.startPoint) {
        return 1 * d;
    }
    return 0;
};
var compareRowsByProgressField = function (a, b, direction) {
    var d = direction === Direction.Desc ? 1 : -1;
    // 'a' comes first (d > 0)
    if (a.progress < b.progress) {
        return -1 * d;
    }
    // 'b' comes first
    if (a.progress > b.progress) {
        return 1 * d;
    }
    return 0;
};
var compareByRows = function (a, b, direction) {
    var d = direction === Direction.Desc ? 1 : -1;
    // 'a' comes first (d > 0)
    if (a.studentName.toLowerCase() < b.studentName.toLowerCase()) {
        return -1 * d;
    }
    // 'b' comes first
    if (a.studentName.toLowerCase() > b.studentName.toLowerCase()) {
        return 1 * d;
    }
    return 0;
};
var groupByLevel = function (students, groupGrade) {
    var tableData = { groupedData: [] };
    var studentsBelow = students.filter(function (s) { return s.testLevel.toString() === 'below_grade'; });
    var studentsParsedBelow = parseTableRow(studentsBelow, groupGrade);
    studentsParsedBelow.sort(function (a, b) {
        return compareRowsBySortField(a, b, Direction.Desc);
    });
    if (studentsParsedBelow.length)
        tableData.groupedData.push({
            group: { name: 'Below grade level', sort: 0 },
            rows: studentsParsedBelow,
        });
    var studentsOnGrade = students.filter(function (s) { return s.testLevel.toString() === 'on_grade'; });
    var studentsParsedOnGrade = parseTableRow(studentsOnGrade, groupGrade);
    studentsParsedOnGrade.sort(function (a, b) {
        return compareRowsBySortField(a, b, Direction.Desc);
    });
    if (studentsParsedOnGrade.length)
        tableData.groupedData.push({
            group: { name: 'On grade level', sort: 1 },
            rows: studentsParsedOnGrade,
        });
    var studentsTbdGrade = students.filter(function (s) { return s.testLevel.toString() === 'tbd_grade'; });
    var studentsParsedTbdGrade = parseTableRow(studentsTbdGrade, groupGrade);
    studentsParsedTbdGrade.sort(function (a, b) {
        return compareRowsBySortField(a, b, Direction.Desc);
    });
    if (studentsParsedTbdGrade.length)
        tableData.groupedData.push({
            group: { name: 'Level TBD', sort: 2 },
            rows: studentsParsedTbdGrade,
        });
    return tableData;
};
var groupByTime = function (students, groupGrade) {
    var tableData = { groupedData: [] };
    var studentsBelow15 = students.filter(function (s) { return s.minInWeekGroup.toString() === 'below_15'; });
    var studentsParsedBelow15 = parseTableRow(studentsBelow15, groupGrade);
    studentsParsedBelow15.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedBelow15.length)
        tableData.groupedData.push({
            group: { name: '<15 min/week', sort: 3 },
            rows: studentsParsedBelow15,
        });
    var studentsBelow1530 = students.filter(function (s) { return s.minInWeekGroup.toString() === 'between_15_and_30'; });
    var studentsParsedBelow1530 = parseTableRow(studentsBelow1530, groupGrade);
    studentsParsedBelow1530.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedBelow1530.length)
        tableData.groupedData.push({
            group: { name: '15-30 min/week', sort: 2 },
            rows: studentsParsedBelow1530,
        });
    var studentsBelow3045 = students.filter(function (s) { return s.minInWeekGroup.toString() === 'between_30_and_45'; });
    var studentsParsedBelow3045 = parseTableRow(studentsBelow3045, groupGrade);
    studentsParsedBelow3045.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedBelow3045.length)
        tableData.groupedData.push({
            group: { name: '30-45 min/week', sort: 1 },
            rows: studentsParsedBelow3045,
        });
    var studentsOver45 = students.filter(function (s) { return s.minInWeekGroup.toString() === 'over_45'; });
    var studentsParsedOver45 = parseTableRow(studentsOver45, groupGrade);
    studentsParsedOver45.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedOver45.length)
        tableData.groupedData.push({
            group: { name: '45+ min', sort: 0 },
            rows: studentsParsedOver45,
        });
    return tableData;
};
var groupByCurrentGrade = function (students, groupGrade) {
    var tableData = { groupedData: [] };
    var studentsPK = students.filter(function (s) {
        return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) ===
            Grades.PK;
    });
    var studentsParsedPK = parseTableRow(studentsPK, groupGrade);
    studentsParsedPK.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedPK.length)
        tableData.groupedData.push({
            group: { name: 'Pre-Kindergarten', sort: 0 },
            rows: studentsParsedPK,
        });
    var studentsK = students.filter(function (s) {
        return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) ===
            Grades.K;
    });
    var studentsParsedK = parseTableRow(studentsK, groupGrade);
    studentsParsedK.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedK.length)
        tableData.groupedData.push({
            group: { name: 'Kindergarten', sort: 1 },
            rows: studentsParsedK,
        });
    var studentsG1 = students.filter(function (s) {
        return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) ===
            Grades.G1;
    });
    var studentsParsedG1 = parseTableRow(studentsG1, groupGrade);
    studentsParsedG1.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedG1.length)
        tableData.groupedData.push({
            group: { name: 'Grade 1', sort: 2 },
            rows: studentsParsedG1,
        });
    var studentsG2 = students.filter(function (s) {
        return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) ===
            Grades.G2;
    });
    var studentsParsedG2 = parseTableRow(studentsG2, groupGrade);
    studentsParsedG2.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedG2.length)
        tableData.groupedData.push({
            group: { name: 'Grade 2', sort: 3 },
            rows: studentsParsedG2,
        });
    var studentsG3 = students.filter(function (s) {
        return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) ===
            Grades.G3;
    });
    var studentsParsedG3 = parseTableRow(studentsG3, groupGrade);
    studentsParsedG3.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedG3.length)
        tableData.groupedData.push({
            group: { name: 'Grade 3', sort: 4 },
            rows: studentsParsedG3,
        });
    var studentsG4 = students.filter(function (s) {
        return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) ===
            Grades.G4;
    });
    var studentsParsedG4 = parseTableRow(studentsG4, groupGrade);
    studentsParsedG4.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedG4.length)
        tableData.groupedData.push({
            group: { name: 'Grade 4', sort: 5 },
            rows: studentsParsedG4,
        });
    var studentsG5 = students.filter(function (s) {
        return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) ===
            Grades.G5;
    });
    var studentsParsedG5 = parseTableRow(studentsG5, groupGrade);
    studentsParsedG5.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedG5.length)
        tableData.groupedData.push({
            group: { name: 'Grade 5', sort: 6 },
            rows: studentsParsedG5,
        });
    var studentsTbd = students.filter(function (s) {
        return (isTbd(s.grade.toString()) ? Grades.TBD : s.grade) ===
            Grades.TBD;
    });
    var studentsParsedTbd = parseTableRow(studentsTbd, groupGrade);
    studentsParsedTbd.sort(function (a, b) {
        return compareRowsByProgressField(a, b, Direction.Asc);
    });
    if (studentsParsedTbd.length)
        tableData.groupedData.push({
            group: { name: 'Level TBD', sort: 7 },
            rows: studentsParsedTbd,
        });
    return tableData;
};
var groupByStudent = function (students, groupGrade) {
    var tableData = { groupedData: [] };
    var studentsParsed = parseTableRow(students, groupGrade);
    studentsParsed.sort(function (a, b) { return compareByRows(a, b, Direction.Desc); });
    if (studentsParsed.length)
        tableData.groupedData.push({
            group: { name: '', sort: 0 },
            rows: studentsParsed,
        });
    return tableData;
};
var useDiagramsData = function (groupId, accountType, schoolId) {
    var memoizedUrl = useMemo(function () {
        return groupId
            ? encodeURI(getDiagramsDataRelativeUrl(groupId, accountType, schoolId))
            : null;
    }, [groupId, accountType, schoolId]);
    var _a = useSWR(memoizedUrl, fetcher2, {
        revalidateOnFocus: false,
    }), data = _a.data, error = _a.error;
    var updatedData = data;
    if (Array.isArray(data === null || data === void 0 ? void 0 : data.students))
        updatedData.students = data.students.map(function (s) { return (__assign(__assign({}, s), { name: escapeSpecialSymbols(s.name) })); });
    var memoData = useMemo(function () { return transformDiagramsData(updatedData); }, [groupId, accountType, schoolId, data]);
    return {
        data: memoData,
        isLoading: !error && !data,
        isError: !!error,
    };
};
export var useTableData = function (tableData, sortType, direction) {
    var data;
    if (!tableData)
        return undefined;
    switch (sortType) {
        case SortTypes.Grade:
            data = tableData.get(SortGroupType.Grade);
            break;
        case SortTypes.Time:
            data = tableData.get(SortGroupType.Time);
            break;
        case SortTypes.Student:
            data = tableData.get(SortGroupType.None);
            break;
        case SortTypes.PT:
        default:
            data = tableData.get(SortGroupType.Level);
            break;
    }
    if (sortType === SortTypes.Student) {
        data === null || data === void 0 ? void 0 : data.groupedData.forEach(function (g) {
            return g.rows.sort(function (a, b) { return compareByRows(a, b, direction); });
        });
    }
    else {
        data === null || data === void 0 ? void 0 : data.groupedData.sort(function (a, b) { return compare(a, b, direction); });
        data === null || data === void 0 ? void 0 : data.groupedData.forEach(function (g) {
            return g.rows.sort(function (a, b) { return compareRowsBySortField(a, b, direction); });
        });
        console.log(data === null || data === void 0 ? void 0 : data.groupedData);
    }
    return data;
};
export { useDiagramsData };
